/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrary1Inputs */

const en_medialibrary1 = /** @type {(inputs: Medialibrary1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Library`)
};

const de_medialibrary1 = /** @type {(inputs: Medialibrary1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediathek`)
};

/**
* | output |
* | --- |
* | "Media Library" |
*
* @param {Medialibrary1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrary1 = /** @type {((inputs?: Medialibrary1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrary1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrary1(inputs)
	return de_medialibrary1(inputs)
});
export { medialibrary1 as "mediaLibrary" }